import axios from 'axios';

const addNewCustomerPaymentApi = async (token, values, edit) => {
  try {
    let url;
    if (!edit) url = '/payments/create';
    else url = '/payments/update';

    const res = await axios.post(url, values, {
      headers: {
        lang: 'ar',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token
      }
    });
    return res;
  } catch (error) {
    throw error;
  }
};

export default addNewCustomerPaymentApi;
